import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/d575b0a6-0900-4163-a903-160e73cf184e.png" 
              alt="STYLINE Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className={`text-2xl font-bold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              STYLINE
            </span>
          </div>

          <div className="flex items-center gap-12">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-base font-medium transition-colors hover:text-cyan-500 ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-base font-medium transition-colors hover:text-cyan-500 ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`text-base font-medium transition-colors hover:text-cyan-500 ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-base font-medium transition-colors hover:text-cyan-500 ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('download')}
            className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-500 text-white font-semibold rounded-full hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 flex items-center gap-2 whitespace-nowrap"
          >
            <i className="ri-download-line"></i>
            Download VPN
          </button>
        </div>
      </div>
    </nav>
  );
}
